import React from 'react';
import { InfoCircleFilled } from '@ant-design/icons';
import { Text } from '@clockout-dev/design-elements';
import styles from '../styles/accessRulesCard.module.scss';

// Derives the panel-level status from the access toggles: any enabled rule
// puts the system in "Paused" (matches the Figma reference); when no rule is
// active the panel reports "Active" with a quieter helper line.
function AccessRulesStatusBanner({ paused, readOnly = false }) {
    const title = paused ? 'System Status: Paused' : 'System Status: Active';
    const description = readOnly
        ? 'Status reflects loaded configuration. Saving access rules is not available yet.'
        : paused
          ? 'Access restricted based on trigger events. Update active rules below.'
          : 'No access restrictions are currently active. Enable a rule below to start enforcing it.';

    return (
        <div className={styles.statusBanner}>
            <span className={styles.statusIcon} aria-hidden="true">
                <InfoCircleFilled />
            </span>
            <div className={styles.statusContent}>
                <Text as="span" size="s" className={styles.statusTitle}>
                    {title}
                </Text>
                <Text as="span" size="xs" className={styles.statusDescription}>
                    {description}
                </Text>
            </div>
        </div>
    );
}

export default AccessRulesStatusBanner;
